import React, {useEffect, useState} from "react";
import {Col, Container, Image, Row, Button, Figure, Spinner} from "react-bootstrap";
import UserInfo from "../modals/UserInfo";
import SubscriptionForm from "../forms/SubscriptionForm";
import axios from "axios";
import LoadingSpinner from "../toolkit/LoadingSpinner";
import {Link, useNavigate} from "react-router-dom";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import {useEmailStorage} from "../../hooks/useEmailStorage";
import {displayYear} from "../../config/global";
import {useSanctum} from "react-sanctum";
import {useStockStorage} from "../../hooks/useStockStorage";
import {useTranslation} from "react-i18next";
import {useToolkit} from "../../hooks/useToolkit";


const Success = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { user } = useSanctum();
    const [isLoading, setLoading] = useState(false);
    const [number, setNumber] = useState(0);
    const [value, setValue] = useState(0);
    const [data, setData] = useState();
    const { getStockStorageToken, removeStockStorageToken, removeSessionStockAll } = useStockStorage();
    const {getAppUniqueToken, renewAppUniqueToken, removeAppUniqueToken} = useAppUniqueToken();
    const [uaToken] = useState(getStockStorageToken);
    const {removeEmailStorageSent, setEmailStorageSent, emailStorageSent} = useEmailStorage();
    const { removeCurrentQuote, removeCurrentTab } = useToolkit();
    
    useEffect(() => {
        window.scroll(0, 0);
        setLoading(true);

        getUserInfo()
            .then(() => setLoading(false))
            .then(() => sendEmail('user'))
            .then(() => sendEmail('admin'))
            .then(() => setEmailStorageSent());

    }, []);

    const handleStartAgain = () => {

        removeSessionStockAll();
        
        removeStockStorageToken();
        renewAppUniqueToken();
        removeEmailStorageSent();

        navigate('/');
    }
    const handleBackToLounge = () => {

        removeCurrentTab();
        removeCurrentQuote();
        removeSessionStockAll();
        removeStockStorageToken();
        removeEmailStorageSent();
        renewAppUniqueToken();

        navigate('/lounge');
    }
    const sendEmail = async (type: string) => {

        //console.log('emailLocalStorageSent: ' + emailStorageSent);

        if(!emailStorageSent)
        {
            //alert('SEND EMAIL!');
            //alert('uaToken: ' + uaToken);

            const payload = {
                uaToken,
                type: type
            };

            let currentEmail = await axios.post('api/email', payload)
                .then(response => {
                    //console.log('api/email');
                    console.log(response.data);
                });
        }
    };
    const getUserInfo = async () => {
        const payload = {
            uaToken,
            status: 'STATUS_CLOSED'
        };

        let currentUserInfo = await axios.post('api/userinfo', payload)
            .then(response => {
                //console.log('api/userinfo');
                //console.log(response.data);

                setNumber(response.data.info.subscriptions_count)
                setValue(response.data.info.stock_value)
            });
    };
    const handleLogout = () => {
        removeAppUniqueToken();
        navigate('/landing');
    };

    return (

        <Container fluid>
            {
                (
                    isLoading ?
                        <LoadingSpinner />
                        :
                        <div className="col col-12 mx-auto my-4">
                            <div className="panel center conferma">
                                <figure className="add_bottom_30">
                                    <img src="img/europaverde.png" height="100px" alt="" /><br />
                                    <h4>Tesseramento Europa Verde {displayYear}</h4>
                                </figure>
                                <center>
                                    Grazie <b>{!isLoading && user && user.user.name} {!isLoading && user && user.user.surname}</b>. La tua richiesta è arrivata correttamente.<br />
                                    Hai inviato n.<b>{!isLoading && (number)}</b>&nbsp;richieste di adesione per l'anno {displayYear}.<br />
                                    L'importo totale delle richieste inviate corrisponde a:&nbsp; <b>{!isLoading && (value)} €</b><br /><br />
                                    Controlla la tua mail, riceverai un messaggio di riepilogo di quanto inviato.<br />
                                    Per qualsiasi problema contatta <a href="mailto:adesioni@europaverde.it">adesioni@europaverde.it</a>
                                    <br />
                                    <br />
                                    <br />
                                    {
                                        /*
                                        uaToken !== getAppUniqueToken() 
                                        ? (
                                            <Button key={'goBackToLounge'} id={'goBackToLounge'} className={'btn_1 yellow'} onClick={() => handleBackToLounge()}>
                                                {t('captions.goBackToLounge')}
                                            </Button> 
                                        )   
                                        : (
                                            <Button key={'startAgain'} id={'startAgain'} className={'btn_1 yellow'} onClick={() => handleStartAgain()}>
                                                {t('captions.startAgain')}
                                            </Button>
                                        )
                                        */
                                    }
                                    
                                    <Button className="btn_1 yellow text-bg-warning mb-2 w-50" 
                                        variant="outline" 
                                        onClick={(e) => handleBackToLounge()}
                                        disabled={isLoading}
                                    >
                                        {
                                            isLoading ? (
                                            <Spinner
                                                as="span"
                                                //animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                            ) : (
                                            t("captions.lounge")
                                            )
                                        }
                                    </Button>
                                    <br />
                                    <Button key={'startAgain'} id={'startAgain'} className={'btn_1 primary mb-2 w-50'} onClick={() => handleStartAgain()}>
                                        {t('captions.startAgain')}
                                    </Button>
                                    <br />
                                    <Button key={'Logout'} id={'Logout'} className={'btn_1 green w-50'} onClick={handleLogout}>
                                        {t('captions.logOut')}
                                    </Button>
                                </center>
                            </div>
                        </div>
                )
            }

            <div className="divider"></div>
        </Container>
    );
};

export default Success;
